import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import ReactTelInput from "react-telephone-input/lib/withStyles";

import "../styles/Loginform.css";
import OTPVerification from "./OTPVerification";
import { API_ROOT, colors, checkStatus, parseJSON } from "../util/constants";
import NewButton from "./FormComponents/NewButton";
import countryFlags from "../images/flags.png";

class LoginOtp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: props.redirect,
      phone: "",
      countryCode: "",
      error: false,
      errorText: "",
      processing: false
    };
  }

  handleInputChange = (telNumber, selectedCountry) => {
    if (telNumber.length <= selectedCountry.dialCode.length) {
      this.setState({ phone: selectedCountry.dialCode });
    } else {
      this.setState({
        phone: telNumber,
        countryCode: selectedCountry.dialCode
      });
    }
  };

  loginotp = e => {
    e.preventDefault();
    if (this.state.phone !== "" && this.state.phone !== "") {
      var phoneNumber = this.state.phone.substring(
        this.state.countryCode.length + 1
      );

      if (this.state.countryCode === "91" && phoneNumber.length < 10) {
        this.setState({ error: true, errorText: "Invalid number" });
        return;
      }

      this.setState({ error: false, errorText: "", processing: true });

      var myRequestUrl = API_ROOT + "loginOtp.php";

      var formData = new FormData();
      formData.append("phone", phoneNumber);
      formData.append("countryCode", this.state.countryCode);

      var self = this;

      fetch(myRequestUrl, {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      })
        .then(checkStatus)
        .then(parseJSON)
        .then(function(data) {
          if (data.status) {
            ReactDOM.render(
              <OTPVerification
                number={data.phone}
                countryCode={self.state.countryCode}
                redirect={self.state.redirect}
              />,
              document.getElementById("login-container")
            );
          } else {
            self.setState({
              error: true,
              errorText: "Phone number not registered.",
              processing: false
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    } else {
      this.setState({
        error: true,
        errorText: "All fields are mandatory.",
        processing: false
      });
    }
  };
  handleClick = () => {
    this.props.loginUsingPass();
  };

  render() {
    return (
      <form method="post" onSubmit={this.loginotp}>
        <ReactTelInput
          defaultCountry="in"
          preferredCountries={["in", "lk", "th", "us", "gb"]}
          flagsImagePath={countryFlags}
          onChange={this.handleInputChange}
          value={this.state.phone}
          autoFormat={false}
          classNames={
            this.state.error ? "phone-intel-number error" : "phone-intel-number"
          }
        />
        {this.state.error && <ErrorText>{this.state.errorText}</ErrorText>}
        <NewButton type="submit" block disabled={this.state.processing}>
          {this.state.processing ? "Submitting..." : "Login"}
        </NewButton>
        <NewButton
          type="button"
          block
          onClick={this.handleClick}
          secondary
          border="1px solid #a0a0a0"
        >
          Login using Password
        </NewButton>
        <Link href="/signup">Don’t have an account? Sign up</Link>
      </form>
    );
  }
}

const ErrorText = styled.p`
  font-size: 16px !important;
  font-weight: 500 !important;
  color: ${colors.error} !important;
  margin: 10px 0 !important;
  padding: 0 !important;
  text-align: center !important;
`;

const Link = styled.a`
  color: #42a5f5 !important;
  font-size: 0.9rem !important;
  text-decoration: none !important;
  user-select: none !important;
  &:hover {
    text-decoration: none !important;
    color: #3ca0c8 !important;
  }
`;
export default LoginOtp;



// WEBPACK FOOTER //
// ./src/components/LoginOtp.js